import { createSlice } from '@reduxjs/toolkit';
import { addNewMake, editMake, editMakeImage, getAllMakes } from './makesService';

const initialState = {
  allMakes: {
    isMakesLoading: null,
    isMakesSuccess: null,
    makesMessage: null,
    pageCount: 0,
    makes: [],
  },
  newMake: {
    isMakeCreating: null,
    isMakeCreated: null,
    makeCreationMsg: null,
  },

  editedMake: {
    isEditingMake: null,
    isMakeEdited: null,
    makeEditedMsg: null
  },

  editedMakeImage: {
    isEditingMakeImage: null,
    isMakeImageEdited: null,
    makeImageEditedMsg: null
  }
};

const makesSlice = createSlice({
  name: 'make',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllMakes.pending, (state) => {
        state.allMakes = {
          ...initialState.allMakes, // Reset to initial state
          isMakesLoading: true,
          makesMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllMakes.rejected, (state, action) => {
        state.allMakes = {
          ...initialState.allMakes,
          isMakesLoading: false,
          isMakesSuccess: false,
          makesMessage: action.payload || 'Error occurred while fetching makes',
        };
      })

      // FULFILLED
      .addCase(getAllMakes.fulfilled, (state, action) => {
        state.allMakes = {
          ...initialState.allMakes,
          isMakesLoading: false,
          isMakesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          makes: action.payload.data || [],
        };
      });

    //Make creating
    builder
      .addCase(addNewMake.pending, (state) => {
        state.newMake = {
          ...initialState.newMake, // Reset to initial state
          isMakeCreating: true,
          makeCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewMake.rejected, (state, action) => {
        state.newMake = {
          ...initialState.newMake,
          isMakeCreating: false,
          isMakeCreated: false,
          makeCreationMsg: action.payload || 'Error occurred while creating the make.',
        };
      })

      // FULFILLED
      .addCase(addNewMake.fulfilled, (state, action) => {
        state.newMake = {
          ...initialState.newMake,
          isMakeCreating: false,
          isMakeCreated: true,
          makeCreationMsg: action.payload || 'Successfully created the make.',
        };
      });

    //Make editing
    builder
      .addCase(editMake.pending, (state) => {
        state.editedMake = {
          ...initialState.editedMake, // Reset to initial state
          isEditingMake: true,
          makeEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editMake.rejected, (state, action) => {
        state.editedMake = {
          ...initialState.editedMake, // Reset to initial state
          isEditingMake: false,
          isMakeEdited: false,
          makeEditedMsg: action.payload || 'Error occurred while editing the make.',
        };
      })

      // FULFILLED
      .addCase(editMake.fulfilled, (state, action) => {
        state.editedMake = {
          ...initialState.editedMake, // Reset to initial state
          isEditingMake: false,
          isMakeEdited: true,
          makeEditedMsg: action.payload || 'Successfully edited the make.',
        };
      });

    //Make image editing
    builder
      .addCase(editMakeImage.pending, (state) => {
        state.editedMakeImage = {
          ...initialState.editedMakeImage, // Reset to initial state
          isEditingMakeImage: true,
          makeImageEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editMakeImage.rejected, (state, action) => {
        state.editedMakeImage = {
          ...initialState.editedMakeImage, // Reset to initial state
          isEditingMakeImage: false,
          isMakeImageEdited: false,
          makeImageEditedMsg: action.payload || 'Error occurred while editing the make image.',
        };
      })

      // FULFILLED
      .addCase(editMakeImage.fulfilled, (state, action) => {
        state.editedMakeImage = {
          ...initialState.editedMakeImage, // Reset to initial state
          isEditingMakeImage: false,
          isMakeImageEdited: false,
          makeImageEditedMsg: action.payload || 'Successfully edited the make image.',
        };
      });
  },
});

export default makesSlice.reducer;
